<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {getLanguage} from "@/util/auth"
export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.$t('App.title'),
      titleTemplate: title => {
        return title
      }
    }
  },
  mounted() {
    this.$i18n.locale = getLanguage() || 'zh';
  }
}
</script>

<style>
body{
  margin: 0px;
  padding: 0px;
}
html {
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue